import { render, staticRenderFns } from "./AddOptionRatio.vue?vue&type=template&id=9ac9e984"
import script from "./AddOptionRatio.vue?vue&type=script&lang=js"
export * from "./AddOptionRatio.vue?vue&type=script&lang=js"
import style0 from "./AddOptionRatio.vue?vue&type=style&index=0&id=9ac9e984&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports